import { useState, ChangeEvent } from "react";
import { Button, FormControlLabel, RadioGroup, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as DownloadIcon } from "../../../assets/download.icon.svg";
import { ExportFileType } from "../../../common/enums/export-file-type";
import { TivaRadioButton } from "../../../components/radio-button/radio-button.comp";

const FileDownloadView = ({
    handleClose
}: {
    handleClose: (arg1?: string, arg2?: ExportFileType) => void;
}) => {
    const [fileName, setFileName] = useState<string>("");
    const [fileType, setFileType] = useState<ExportFileType>(ExportFileType.pdf);

    const handleFileNameChange = (evt: ChangeEvent<HTMLInputElement>) => {
        const val = evt.target?.value;
        setFileName(val ?? "");
    };

    const handleFileTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFileType((event.target as HTMLInputElement).value as ExportFileType);
    };

    const handleCloseClick = (fileName?: string, exportType?: ExportFileType) => {
        handleClose(fileName, exportType);
    };

    const handleDownloadClick = () => {
        handleCloseClick(fileName, fileType);
    };

    return (
        <div className="file-download">
            <div className="file-download-title">
                <SvgIcon
                    className="file-download-title__icon"
                    component={DownloadIcon}
                    inheritViewBox
                />
                <span className="file-download-title__text">Download Data as File</span>
            </div>
            <div className="file-download-file-name">
                <input
                    type="text"
                    aria-label="File Name"
                    placeholder="File Name"
                    onChange={handleFileNameChange}
                    value={fileName}
                />
            </div>
            <div className="file-download-types">
                <div className="file-download-types-title">Choose file format</div>
                <RadioGroup
                    className="file-download-type-list"
                    value={fileType}
                    defaultValue={ExportFileType.pdf}
                    onChange={handleFileTypeChange}
                >
                    <FormControlLabel
                        className="file-download-type-item"
                        control={<TivaRadioButton />}
                        value={ExportFileType.pdf}
                        label={ExportFileType.pdf}
                    />
                    <FormControlLabel
                        className="file-download-type-item"
                        control={<TivaRadioButton />}
                        value={ExportFileType.csv}
                        label={ExportFileType.csv}
                    />
                    <FormControlLabel
                        className="file-download-type-item"
                        control={<TivaRadioButton />}
                        value={ExportFileType.xls}
                        label={ExportFileType.xls}
                    />
                </RadioGroup>
            </div>
            <div className="file-download-action">
                <Button
                    className="thirt-button"
                    variant="outlined"
                    onClick={() => handleCloseClick()}
                >
                    Cancel
                </Button>
                <Button
                    className="primary-button file-download-action__button-margin"
                    variant="outlined"
                    disabled={!fileName}
                    onClick={handleDownloadClick}
                >
                    Download
                </Button>
            </div>
        </div>
    );
};

export default FileDownloadView;
